export const claimTypes = [
    { id: 1, value: 'ACCIDENT_COLLISION', label: 'Accident or collision' } /* Used in the Excess Paid Question */,
    { id: 2, value: 'NATURAL_EVENT', label: 'Natural event (flood, hail, bushfire or storm, etc)' },
    { id: 3, value: 'FIRE', label: 'Fire' },
    { id: 4, value: 'THEFT', label: 'Theft' },
    { id: 5, value: 'ATTEMPTED_THEFT', label: 'Attempted theft' },
    { id: 6, value: 'WINDSCREEN_GLASS_ONLY_DAMAGE', label: 'Windscreen or glass only damage' },
    { id: 7, value: 'ARSON_MALICIOUS_DAMAGE_VANDALISM', label: 'Arson, malicious damage or vandalism' },
    { id: 8, value: 'ACCIDENT_INVOLVING_ANIMAL', label: 'Accident involving an animal' }
];

export const monthlyArray = [
    { id: 1, label: 'January', value: 'JANUARY' },
    { id: 2, label: 'February', value: 'FEBRUARY' },
    { id: 3, label: 'March', value: 'MARCH' },
    { id: 4, label: 'April', value: 'APRIL' },
    { id: 5, label: 'May', value: 'MAY' },
    { id: 6, label: 'June', value: 'JUNE' },
    { id: 7, label: 'July', value: 'JULY' },
    { id: 8, label: 'August', value: 'AUGUST' },
    { id: 9, label: 'September', value: 'SEPTEMBER' },
    { id: 10, label: 'October', value: 'OCTOBER' },
    { id: 11, label: 'November', value: 'NOVEMBER' },
    { id: 12, label: 'December', value: 'DECEMBER' }
];

export const badgeButtons = [{ id: 1, value: 'YES', innerLabel: 'Yes', variant: 'size_xs_40_sm_40' }, { id: 2, value: 'NO', innerLabel: 'No', variant: 'size_xs_40_sm_40' }];
export const timeframeButtons = [
    { id: 1, value: 'YES', innerLabel: 'Within the last 3 years', variant: 'size_xs_40_sm_40' },
    { id: 2, value: 'NO', innerLabel: 'More than 3 years and up to 5 years ago', variant: 'size_xs_40_sm_40' }
];
